import script from "./DetalheJogo.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalheJogo.vue?vue&type=script&setup=true&lang=js"

import "./DetalheJogo.vue?vue&type=style&index=0&id=674d8ea2&lang=css"

const __exports__ = script;

export default __exports__